import { CommonModule } from '@angular/common'
import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core'
import { MatMenuTrigger } from '@angular/material/menu'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { Canvas } from '../models/canvas.model'

@Component({
  selector: 'ddc-canvas-row',
  templateUrl: './ddc-canvas-row.component.html',
  styleUrls: ['./ddc-canvas-row.component.scss'],
  imports: [CommonModule, AngularMaterialsModules],
  standalone: true,
})
export class DdcCanvasRowComponent implements AfterViewChecked {
  @Input() canvas: Canvas
  @Input() isSelected: boolean = false
  @Input() isDirty: boolean = false
  @Input() isEditing: boolean = false

  @Output() selectCanvas = new EventEmitter<Canvas>()
  @Output() deleteCanvas = new EventEmitter<Canvas>()
  @Output() duplicateCanvas = new EventEmitter<Canvas>()
  @Output() renameCanvas = new EventEmitter<{ canvas: Canvas; title: string }>()

  @ViewChild(MatMenuTrigger) contextMenuTrigger: MatMenuTrigger
  @ViewChild('menuTriggerEl', { read: ElementRef }) menuTriggerEl: ElementRef<HTMLElement>
  @ViewChild('titleInput') titleInput: ElementRef<HTMLInputElement>

  contextMenuPosition = { x: 0, y: 0 }
  editTitle = ''
  private needsFocus = false

  ngAfterViewChecked(): void {
    if (this.needsFocus && this.titleInput) {
      this.titleInput.nativeElement.focus()
      this.titleInput.nativeElement.select()
      this.needsFocus = false
    }
  }

  startEditing(): void {
    this.editTitle = this.canvas.title
    this.isEditing = true
    this.needsFocus = true
  }

  confirmRename(): void {
    const trimmed = this.editTitle.trim()
    if (trimmed && trimmed !== this.canvas.title) {
      this.renameCanvas.emit({ canvas: this.canvas, title: trimmed })
    }
    this.isEditing = false
  }

  cancelEditing(): void {
    this.isEditing = false
  }

  onEditKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.confirmRename()
    } else if (event.key === 'Escape') {
      event.preventDefault()
      this.cancelEditing()
    }
  }

  onSelect(): void {
    if (!this.isEditing) {
      this.selectCanvas.emit(this.canvas)
    }
  }

  onDelete(): void {
    this.deleteCanvas.emit(this.canvas)
  }

  onDuplicate(): void {
    this.duplicateCanvas.emit(this.canvas)
  }

  onRename(): void {
    this.startEditing()
  }

  onContextMenu(event: MouseEvent): void {
    event.preventDefault()
    event.stopPropagation()

    // Position trigger relative to its offset parent (needed because backdrop-filter
    // creates a new containing block, making position:fixed act as position:absolute)
    const triggerEl = this.menuTriggerEl?.nativeElement
    if (triggerEl) {
      const parent = triggerEl.offsetParent as HTMLElement
      const parentRect = parent ? parent.getBoundingClientRect() : { left: 0, top: 0 }
      this.contextMenuPosition = {
        x: event.clientX - parentRect.left,
        y: event.clientY - parentRect.top,
      }
    } else {
      this.contextMenuPosition = { x: event.clientX, y: event.clientY }
    }

    this.contextMenuTrigger.openMenu()
  }
}
